export enum ProductType {
  Scheduling = 1,
  Booking = 2,
  Form = 3,
  Calendar = 4,
}

export function getProductTypeByTags(tags: string[]) {
  if (tags && Array.isArray(tags)) {
    if (tags.includes('booking')) {
      return ProductType.Booking;
    }
  }
  return ProductType.Scheduling;
}
